import { Coins, Scale, Trophy, Gamepad2, Sparkles, Package } from 'lucide-react';

export const CATEGORIES = [
  { value: 'coins', label: 'Coins', icon: Coins, description: 'Rare & collectible coins', image: 'https://images.unsplash.com/photo-1612734425688-d7a59377e5f7?w=800' },
  { value: 'precious_metals', label: 'Precious Metals', icon: Scale, description: 'Gold, silver & bullion', image: 'https://images.unsplash.com/photo-1610375461246-83df859d849d?w=800' },
  { value: 'sports_cards', label: 'Sports Cards', icon: Trophy, description: 'Baseball, basketball, football & more', image: 'https://images.unsplash.com/photo-1629480081920-12a3714e3987?w=800' },
  { value: 'tcg', label: 'TCG / Gaming Cards', icon: Gamepad2, description: 'Pokemon, Magic, Yu-Gi-Oh & more', image: 'https://images.unsplash.com/photo-1613771404784-3a5686aa2be3?w=800' },
  { value: 'collectibles_nonsports', label: 'Collectibles', icon: Sparkles, description: 'Marvel, Star Wars, pop culture', image: 'https://images.unsplash.com/photo-1633869699811-cd4f63049b36?w=800' },
  { value: 'other', label: 'Other Assets', icon: Package, description: 'Other valuable items', image: 'https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?w=800' },
];

export const SUBCATEGORIES = {
  sports_cards: [
    { value: 'baseball', label: 'Baseball' },
    { value: 'basketball', label: 'Basketball' },
    { value: 'football', label: 'Football' },
    { value: 'soccer', label: 'Soccer' },
    { value: 'hockey', label: 'Hockey' },
    { value: 'boxing_mma', label: 'Boxing / MMA' },
    { value: 'racing', label: 'Racing' },
    { value: 'other_sports', label: 'Other Sports' },
  ],
  tcg: [
    { value: 'pokemon', label: 'Pokemon' },
    { value: 'magic_the_gathering', label: 'Magic: The Gathering' },
    { value: 'yugioh', label: 'Yu-Gi-Oh' },
    { value: 'one_piece', label: 'One Piece' },
    { value: 'lorcana', label: 'Lorcana' },
    { value: 'flesh_and_blood', label: 'Flesh and Blood' },
    { value: 'other_tcg', label: 'Other TCG' },
  ],
  collectibles_nonsports: [
    { value: 'marvel_dc', label: 'Marvel / DC' },
    { value: 'star_wars', label: 'Star Wars' },
    { value: 'disney', label: 'Disney' },
    { value: 'tv_movies', label: 'TV / Movies' },
    { value: 'music', label: 'Music' },
    { value: 'historical_political', label: 'Historical / Political' },
    { value: 'other_pop_culture', label: 'Other Pop Culture' },
  ],
};

export const CONDITIONS = [
  { value: 'raw', label: 'Raw' },
  { value: 'graded', label: 'Graded' },
  { value: 'sealed', label: 'Sealed' },
  { value: 'used_played', label: 'Used / Played' },
  { value: 'near_mint', label: 'Near Mint' },
  { value: 'excellent', label: 'Excellent' },
  { value: 'good', label: 'Good' },
  { value: 'poor', label: 'Poor' },
  { value: 'new', label: 'New' },
  { value: 'like_new', label: 'Like New' },
  { value: 'fair', label: 'Fair' },
];

export const GRADING_COMPANIES = [
  { value: 'PSA', label: 'PSA' },
  { value: 'BGS', label: 'BGS / Beckett' },
  { value: 'CGC', label: 'CGC' },
  { value: 'SGC', label: 'SGC' },
  { value: 'Raw', label: 'Raw / Ungraded' },
];

export const CARD_CATEGORIES = ['sports_cards', 'tcg', 'collectibles_nonsports'];

export function isCardCategory(cat) {
  return CARD_CATEGORIES.includes(cat);
}

export function getCategoryLabel(value) {
  return CATEGORIES.find(c => c.value === value)?.label || value?.replace(/_/g, ' ') || '';
}

export function getSubcategoryLabel(cat, subValue) {
  return SUBCATEGORIES[cat]?.find(s => s.value === subValue)?.label || subValue?.replace(/_/g, ' ') || '';
}
